import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteCourseDetailedTabsComponent } from './website-course-detailed-tabs.component'
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap'
import { SharedModule } from '../shared/shared.module'

@NgModule({
  declarations: [WebsiteCourseDetailedTabsComponent],
  imports: [
    CommonModule,
    NgbNavModule,
    SharedModule
  ],
  exports: [WebsiteCourseDetailedTabsComponent]
})
export class WebsiteCourseDetailedTabsModule { }
